import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=47295ad7&scoped=true&"
import script from "./Event.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Event.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Event.vue?vue&type=style&index=0&id=47295ad7&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47295ad7",
  null
  
)

export default component.exports